import { render, staticRenderFns } from "./WeeklyReportManagement.vue?vue&type=template&id=045003f0&scoped=true"
import script from "./WeeklyReportManagement.vue?vue&type=script&lang=js"
export * from "./WeeklyReportManagement.vue?vue&type=script&lang=js"
import style0 from "./WeeklyReportManagement.vue?vue&type=style&index=0&id=045003f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045003f0",
  null
  
)

export default component.exports